

























import Vue from "vue"
import PSampleProfile from "../../../../guideline/util/PSampleProfile.vue"
import SectionTitle from "~/components/guideline/util/SectionTitle.vue"
import RowGroup from "~/components/guideline/util/RowGroup.vue"
import ColumnWithIcon from "~/components/guideline/util/ColumnWithIcon.vue"
import { DESCRIPTION_ICON } from "~/config/icon"
import EditItemDescription from "~/components/guideline/util/EditItemDescription.vue"

export default Vue.extend({
  components: {
    SectionTitle,
    RowGroup,
    ColumnWithIcon,
    EditItemDescription,
    PSampleProfile,
  },
  props: {
    philosophy: {
      type: String,
      required: true,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      icon: {
        description: DESCRIPTION_ICON,
      },
      sampleText:
        "希望したい点（リモート必須、稼働時間の固定は避けたい、経験を活かしながら新たな領域へチャレンジできるなど）",
    }
  },
  computed: {
    editLinkForSectionTitle(): string {
      if (!this.isEditable) {
        return ""
      }
      return "/profiles/edit/philosophy"
    },
  },
})
